import React from "react";
import { X } from "lucide-react";
import { bytesToReadable } from "../../utils/uploadLimits";
import "./AttachmentBadges.css";

function AttachmentThumb({ file, alt = "attachment thumbnail" }) {
  const [src, setSrc] = React.useState("");

  React.useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  if (!src) return null;

  return (
    <div className="ab-thumb">
      <img
        className="ab-thumb-img"
        src={src}
        alt={alt}
        draggable={false}
      />
    </div>
  );
}

function inferKind({ name = "", type = "" }) {
  const mime = (type || "").toLowerCase();
  const ext = (name || "").split(".").pop()?.toLowerCase();

  if (mime.startsWith("image/")) return { kind: "image", label: "IMAGE" };
  if (mime.includes("pdf") || ext === "pdf") return { kind: "pdf", label: "PDF" };
  if (mime.includes("spreadsheet") || ["xls", "xlsx", "csv"].includes(ext))
    return { kind: "excel", label: "EXCEL" };
  if (mime.includes("wordprocessingml") || ["doc", "docx"].includes(ext))
    return { kind: "word", label: "WORD" };
  if (mime.includes("presentation") || ["ppt", "pptx"].includes(ext))
    return { kind: "ppt", label: "PPT" };

  return { kind: "file", label: "FILE" };
}

export default function AttachmentBadges({
    documents = [],
    docFiles = [],
    onRemove,
    showThumbs = true,
    className = "",
  }) {
    if (!documents.length) return null;
  
    return (
      <div className={`ab-wrap ${className}`}>
        <div className="ab-row" role="list">
          {documents.map((d, idx) => {
            const f = docFiles?.[idx];
            const fileType = (f?.type || d.type || "").toLowerCase();
            const { kind, label } = inferKind({ name: d.name, type: fileType });
  
            return (
              <div key={d.id} className={`ab-badge kind-${kind}`} role="listitem">
                <button
                  type="button"
                  className="ab-remove"
                  onClick={() => onRemove?.(d.id)}
                  aria-label={`Remove ${d.name}`}
                  title="Remove"
                >
                  <X size={24} />
                </button>
  
                {showThumbs && kind === "image" && f && (
                  <AttachmentThumb file={f} alt={d.name} />
                )}
  
                <div className="ab-kind">{label}</div>
  
                <div className="ab-meta">
                  <div className="ab-name">{d.name}</div>
                  <div className="ab-sub">{bytesToReadable(d.size)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  